import { useState, useContext, useEffect } from "react";
import { IconButton, Menu, MenuItem } from "@material-ui/core";
import Box from "@mui/material/Box";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { eliminaCompetenceEvaluationModal } from "../../../context/PerformanceEvaluationContext/Actions";
import PerformanceEvaluationContext from "../../../context/PerformanceEvaluationContext/PerformanceEvaluationContext";
import { createCompetenceEvaluationModal } from "../../../context/PerformanceEvaluationContext/Actions";
import { useQuery } from "@apollo/client";
import { GET_COMPETENCE_USED_IN_MODEL_EVALUATION } from "../../../Querys/querys";

const MenuCompetencePerformanceEvaluation = (props: any) => {
  const { dispatch } = useContext(PerformanceEvaluationContext);

  const [anchorEl, setAnchorEl] = useState<any>(null);
  const open = Boolean(anchorEl);
  const openMenu = (e: any): void => {
    setAnchorEl(e.currentTarget);
  };
  const [disable, setDisable] = useState(false);
  const { data: getIfCompetenceUsedInModelEvaluation } = useQuery(
    GET_COMPETENCE_USED_IN_MODEL_EVALUATION,
    {
      variables: {
        getCompetenceUsedInModelEvaluationId: parseInt(props.id),
      },
    }
  );
  const conteo =
    getIfCompetenceUsedInModelEvaluation
      ?.GET_COMPETENCE_USED_IN_MODEL_EVALUATION[0].conteo;

  useEffect(() => {
    if (
      getIfCompetenceUsedInModelEvaluation &&
      getIfCompetenceUsedInModelEvaluation?.GET_COMPETENCE_USED_IN_MODEL_EVALUATION &&
      conteo > 0
    ) {
      setDisable(true);
    }
  });
  const updateModal = async (id: any) => {
    setAnchorEl(null);
    console.log(id);
    createCompetenceEvaluationModal(
      { _id: id, updateCompetencePerformanceEvaluation: true },
      dispatch
    );
  };

  const deleteModal = async (id: any) => {
    setAnchorEl(null);
    eliminaCompetenceEvaluationModal(
      { _id: id, eliminaCompetencePerformanceEvaluation: true },
      dispatch
    );
  };

  return (
    <>
      <Box mr={2} className="menuListNewPrestacion">
        <IconButton onClick={openMenu} className="menuListOptionNewPrestacion">
          <MoreVertIcon className="moreOptionNewPrestacion" />
        </IconButton>
      </Box>

      <Menu
        className="MoreVerIcon"
        anchorEl={anchorEl}
        open={open}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        onClose={() => setAnchorEl(null)}
      >
        {/* {CheckPermission("Competence.Editar") && ( */}

        {/* {props.item.status==="definicion" ? */}
        <MenuItem onClick={() => updateModal(props.id)}>
          <div className="contenedorTextoMenuPrestacion">
            <span className="textoMenuEditarPres">Editar</span>
          </div>
          <div className="imgEditaPres">
            <img
              className="iconoMenuPres"
              src="/assets/svg/icono-editar.svg"
              alt="Editar"
            />
          </div>
        </MenuItem>
        {/* :<></>
                } */}

        {
          /* )}
                {CheckPermission("Competence.Eliminar") && ( */
          disable ? (
            <MenuItem onClick={() => deleteModal(props.id)} disabled>
              <div className="contenedorTextoMenuPrestacion">
                <span className="textoMenuEliminarPrestacion">Eliminar</span>
              </div>
              <div className="imgDeletePres">
                <img
                  className="iconoMenuEliminarPrestacion"
                  src="/assets/svg/icono-eliminar.svg"
                  alt="Eliminar"
                />
              </div>
            </MenuItem>
          ) : (
            <MenuItem onClick={() => deleteModal(props.id)}>
              <div className="contenedorTextoMenuPrestacion">
                <span className="textoMenuEliminarPrestacion">Eliminar</span>
              </div>
              <div className="imgDeletePres">
                <img
                  className="iconoMenuEliminarPrestacion"
                  src="/assets/svg/icono-eliminar.svg"
                  alt="Eliminar"
                />
              </div>
            </MenuItem>
          )
          /*  )} */
        }
      </Menu>
    </>
  );
};

export default MenuCompetencePerformanceEvaluation;
